module.exports = __webpack_public_path__ + "img/enhancefeed_logo.9f34b3fa.svg";